import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listar(paginacao) {
  return axios.get(`bancos`, {params: paginacao})
    .then(response => response.data);
}

function buscar(busca) {
  return axios.get(`bancos/buscar?busca=${busca}`)
    .then(response => response.data);
}

function buscarPorCodigo(codigo) {
  return axios.get(`bancos/buscarCodigo?codigo=${codigo}`)
    .then(response => response.data);
}

function abrir(id) {
  return axios.get(`/bancos/${id}`)
    .then(response => response.data);
}

function salvar(banco) {
  return axios.post('/bancos', banco)
    .then(response => response.data);
}

function atualizar(banco) {
  return axios.put(`/bancos/${banco.id}`, banco)
    .then(response => response.data)
}

function excluir(id) {
  return axios.delete(`/bancos/${id}`)
    .then(response => response.data);
}


export default {
  listar,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir
}
